module.exports = __webpack_public_path__ + "img/LF008-07.7e55b238.jpg";